<template>
  <PageWrapper>
    <NavbarMain />
    <FilesWrapper />
    <Footer />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import FilesWrapper from '@/components/files/FilesWrapper.vue'
import Footer from '@/components/_shared/Footer.vue'

export default {
  name: 'Drafts',
  components: {
    PageWrapper,
    NavbarMain,
    FilesWrapper,
    Footer
  }
}
</script>
